import axios from "axios";
import { getCookieValue } from "../js/utils/cookies";

// API URL configuration based on environment
const API_URL =
	import.meta.env.MODE === "production"
		? import.meta.env.VITE_PROD_API_URL || "https://goodglows.com/api/goodglows"
		: import.meta.env.MODE === "development" ||
			  import.meta.env.MODE === "developmentstaging"
			? import.meta.env.VITE_DEV_API_URL || "http://localhost:1000/api"
			: import.meta.env.MODE === "local"
				? import.meta.env.VITE_LOCAL_API_URL || "http://localhost:1000/api"
				: import.meta.env.MODE === "staging"
					? import.meta.env.VITE_STAGING_API_URL ||
						"https://test.goodglows.com/api/goodglows"
					: import.meta.env.VITE_DEV_API_URL || "http://localhost:1000/api";

// Image path configuration based on environment
const IMAGE_PATH =
	import.meta.env.MODE === "production" ||
	import.meta.env.MODE === "staging" ||
	import.meta.env.MODE === "developmentstaging"
		? import.meta.env.VITE_PROD_IMAGE_PATH || "/static/goodglows/images"
		: import.meta.env.MODE === "development"
			? import.meta.env.VITE_DEV_IMAGE_PATH || "/images"
			: import.meta.env.MODE === "local"
				? import.meta.env.VITE_LOCAL_IMAGE_PATH || "/images"
				: import.meta.env.VITE_DEV_IMAGE_PATH || "/images";

export const MEDIA_PATH =
	import.meta.env.MODE === "production"
		? import.meta.env.VITE_PROD_QR_BASE_URL
		: import.meta.env.MODE === "staging"
			? import.meta.env.VITE_STAGE_QR_BASE_URL
			: import.meta.env.MODE === "development"
				? import.meta.env.VITE_DEV_QR_BASE_URL
				: import.meta.env.VITE_DEV_QR_BASE_URL;

export const SUBTITLE_PATH =
	import.meta.env.MODE === "production" ||
	import.meta.env.MODE === "staging" ||
	import.meta.env.MODE === "developmentstaging"
		? import.meta.env.VITE_PROD_SUBTITLE_PATH || "/static/goodglows/subtitles"
		: import.meta.env.MODE === "development"
			? import.meta.env.VITE_DEV_SUBTITLE_PATH || "/subtitles"
			: import.meta.env.MODE === "local"
				? import.meta.env.VITE_LOCAL_SUBTITLE_PATH || "/subtitles"
				: import.meta.env.VITE_DEV_SUBTITLE_PATH || "/subtitles";

// SESSION_ID getter that dynamically retrieves session ID
export const SESSION_ID = () => {
	return (
		getCookieValue("goodglows_sessionid") ||
		localStorage.getItem("goodglows_sessionid")
	);
};

const VIDEO_PATH =
	import.meta.env.MODE === "production" ||
	import.meta.env.MODE === "staging" ||
	import.meta.env.MODE === "developmentstaging"
		? import.meta.env.VITE_PROD_VIDEO_PATH || "/static/goodglows/videos"
		: import.meta.env.MODE === "development"
			? import.meta.env.VITE_DEV_VIDEO_PATH || "/videos"
			: import.meta.env.MODE === "local"
				? import.meta.env.VITE_LOCAL_VIDEO_PATH || "/videos"
				: import.meta.env.VITE_DEV_VIDEO_PATH || "/videos";

// Configure axios instance
const apiClient = axios.create({
	baseURL: API_URL,
	withCredentials: true,
});

// Add request interceptor to dynamically set CSRF token
apiClient.interceptors.request.use(
	(config) => {
		const csrfToken = getCookieValue("csrftoken");
		if (csrfToken) {
			config.headers["X-CSRFToken"] = csrfToken;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export { API_URL, IMAGE_PATH, apiClient, VIDEO_PATH };
